import { TAction } from './types/action';

// Action Types
export const SET_EVENT_REGISTRATION_DATA = 'EVENT_REGISTRATION/SET_EVENT_REGISTRATION_DATA';
export const SET_EVENT_REGISTRATION_FORM_STATE = 'EVENT_REGISTRATION/SET_EVENT_REGISTRATION_FORM_STATE';
export const CLEAR_EVENT_REGISTRATION_DATA = 'EVENT_REGISTRATION/CLEAR_EVENT_REGISTRATION_DATA';
export const SHOW_LOADING_SPINNER = 'EVENT_REGISTRATION/SHOW_LOADING_SPINNER';
export const FORCE_RELOAD = 'EVENT_REGISTRATION/FORCE_RELOAD';

// Action Creator
const EventRegistrationActionCreator = {
  setEventRegistrationData(params: any): TAction<any> {
    return {
      type: SET_EVENT_REGISTRATION_DATA,
      payload: params
    };
  },

  forceReload(): TAction<any> {
    return {
      type: FORCE_RELOAD,
      payload: {}
    };
  },

  setEventRegistrationFormState(params: any): TAction<any> {
    return {
      type: SET_EVENT_REGISTRATION_FORM_STATE,
      payload: params
    };
  },

  clearEventRegistrationData(): TAction<any> {
    return {
      type: CLEAR_EVENT_REGISTRATION_DATA,
      payload: null
    };
  },

  showLoadingSpinner(show: boolean): TAction<boolean> {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default EventRegistrationActionCreator;
